import React, { useRef, useState } from 'react';
import ToolbarMenu from './ToolbarMenu';

interface ISelectedActionsButtonProps {
    label: string;
    editingMode: boolean;
    onToggleEditing: () => void;
    onAddToFilter?: () => void | Promise<void>;
}

const itemClass = `block w-full px-3 py-2 text-left text-[13px] whitespace-nowrap transition-colors
    text-[#2255a1] dark:text-[#eef2ff]
    hover:bg-[#153c76] hover:text-[#eef2ff]
    dark:hover:bg-[#eef2ff] dark:hover:text-[#1e293b]`;

const SelectedActionsButton: React.FC<ISelectedActionsButtonProps> = ({ label, editingMode, onToggleEditing, onAddToFilter }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);

    const run = (action?: () => void | Promise<void>) => () => {
        setOpen(false);
        action?.();
    };

    return (
        <div ref={anchorRef} className="relative flex items-center ml-[7px]" style={{ minWidth: 0 }}>
            <button
                onClick={() => setOpen(v => !v)}
                className="flex items-center gap-[5px] h-[26px] px-[10px] rounded-[4px] text-[12px] transition-colors
                    bg-[#eef2ff] text-[#2255a1] border border-[#d3ddec]
                    hover:bg-[#2255a1] hover:text-white hover:border-[#2255a1]
                    dark:bg-[#1e293b] dark:text-[#d3ddec] dark:border-[#153c76]
                    dark:hover:bg-[#eef2ff] dark:hover:text-[#1e293b] dark:hover:border-[#eef2ff]
                    select-none whitespace-nowrap"
            >
                {label}
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" className={`transition-transform shrink-0 ${open ? 'rotate-180' : ''}`}>
                    <path d="M1 2.5l3 3 3-3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>
            <ToolbarMenu
                open={open}
                onClose={() => setOpen(false)}
                anchorRef={anchorRef}
                className="rounded-[6px] shadow-xl border overflow-hidden bg-[#eef2ff] border-[#d3ddec] dark:bg-[#1e293b] dark:border-[#153c76]"
            >
                <button onClick={run(onToggleEditing)} className={itemClass}>
                    {editingMode ? 'Завершить редактирование' : 'Редактировать'}
                </button>
                {onAddToFilter && (
                    <button onClick={run(onAddToFilter)} className={itemClass}>
                        Добавить в фильтр
                    </button>
                )}
                <button onClick={run()} className={itemClass}>
                    В избранное
                </button>
            </ToolbarMenu>
        </div>
    );
};

export default SelectedActionsButton;
